export const MINUTE = 60 * 1000
export const HOUR = 60 * MINUTE

export const createDelayTimeFromNormalized = (time: number, unit: string) => {
  if (unit === 'hour') {
    return time * HOUR
  }

  return time * MINUTE
}

export const createDisplayTimeFromMs = (time: number, unit: string) => {
  if (unit === 'hour') {
    const realHours = time / HOUR
    return Math.round(realHours)
  }

  return time / MINUTE
}

export const determineDelayUnit = (delay: number) => {
  const maybeHours = delay / HOUR
  if (Number.isInteger(maybeHours)) {
    return 'hour'
  }

  return 'minute'
}

export const humanizeDelays = (delay: number) => {
  const displayTime = createDisplayTimeFromMs(delay, determineDelayUnit(delay))
  return `${displayTime} ${determineDelayUnit(delay)}`
}

export const toEpochMilli = (date: string | number | Date) => {
  const dateObj = new Date(date)
  return dateObj.getTime() - dateObj.getTimezoneOffset() * 60 * 1000
}
